import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import activate from '../components/Activatecode/activate'
import Main from '../components/main/main'
import manage from '../components/manage/manage'
import Lobby from '../components/Lobby/lobbyHost'
import LobbyJoin from '../components/Lobby/lobbyJoin'
import mainlobbyjoin from '../components/Lobby/mainlobbyjoin'
import Join from '../components/Lobby/OTP/mainOTP'
import lobbyOTP from '../components/Lobby/lobbyOTP'
import OTP from '../components/Lobby/OTP'
import redirectlobby from '../components/Lobby/redirectlobby'
import LobbyIncognito from '../components/Lobby/lobbyIncognito'
import LobbyBot from '../components/Lobby/lobbyBot.vue'
import BacktolobbyHost from '../components/Lobby/backtolobbyHost'
import reporthistory from '../components/report/reporthistory.vue'
import loadding from '../components/loadingpage/loadding.vue'
import downloadvideo from '../components/report/downloadvideo'
import joinpage from '../components/Lobby/joinpage.vue'
import loadinglogin from '../components/Login/loadinglogin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/joinpage',
    name: 'joinpage',
    component: joinpage
  },
  {
    path: '/manage',
    name: 'manage',
    component: Main,
    children: [
      { path: '/', component: manage },
      { path: '/otp', name: 'otp', component: OTP },
      { path: '/lobbyOTP', name: 'lobbyOTP', component: lobbyOTP },
      { path: '/lobby', name: 'Lobby', component: Lobby },
      { path: '/lobbyJoin', name: 'lobbyJoin', component: LobbyJoin },
      { path: '/backtolobbyHost', name: 'backtolobbyHost', component: BacktolobbyHost },
      { path: '/redirectlobby', component: redirectlobby },
      { path: '/reporthistory', component: reporthistory },
      { path: '/loadding', component: loadding },
      { path: '/downloadvideo', component: downloadvideo },
      { path: '/loadinglogin', component: loadinglogin },
    ]
  },
  // { path: '/loadinglogin',
  //   name: 'loadinglogin',
  //  component: loadinglogin },

  {
    path: '/join',
    name: 'mainlobbyjoin',
    component: mainlobbyjoin,
    children: [
      { path: '/', component: Join }
    ]
  },
  {
    path: '/lobbyIncognito',
    name: 'LobbyIncognito',
    component: LobbyIncognito
  },
  {
    path: '/lobbybot',
    name: 'LobbyBot',
    component: LobbyBot
  },
  {
    path: '/activate',
    name: 'activate',
    component: activate
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
